import { Settings } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import Loading from "../../components/Loading";
import SettingsDrawer from "../../components/SettingsDrawer";
import { useApiKey } from "../../domain/crud";
import { useApiKeyParams } from "../../paths";
import { selectData } from "../../utils";
import { EditForm } from "./components/EditForm";

export function EditApiKey() {
  const { apiKeyId } = useApiKeyParams();

  const apiKeyQuery = useApiKey(apiKeyId, { select: selectData });

  return (
    <>
      <Helmet>
        <title>Edit API Key</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="Edit API Key"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <Container fixed>
              {apiKeyQuery.isSuccess ? (
                <EditForm apiKey={apiKeyQuery.data} />
              ) : (
                <Loading type="circular" />
              )}
            </Container>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
